<template>
  <div class="packages">
    <div class="choice-box">
      <img class="back-btn" src="@/assets/img/back.png" alt="" @click="backHandler" />
      <h3 class="title">选择课程</h3>
      <ul>
        <li v-for="list in this.allPackages" :key="list._id" :class="[{'li-live':list.type === 'live'},{'li-scratch':list.type !== 'live'}]" @click="packageClick(list)" >
        <!-- <li v-for="list in this.allPackages" :key="list._id" :class="list.type === 'live' ? 'li-live':'li-scratch'" @click="packageClick(list)" > -->
          <img class="poster" :src="list.poster" alt="" />
          <div class="info">
            <h4>{{list.name.zh}}</h4>
            <p>{{list.totalUnits}}课时（{{isSuccessHandler(list)}}）</p>
          </div>
          <img class="state" v-show="list._id === packageId" src="@/assets/images/pknow.png" alt="" />
          <!-- <img class="state" v-show="isSuccessHandler (list) === '正在学习'" src="@/assets/images/pking.png" alt="" /> -->
          <!-- <div class="lock"><img src="@/assets/images/lock.png" alt="" /></div> -->
        </li>
        <li v-for="list in this.recommended" :key="list._id" :class="list.type === 'live' ? 'li-live':'li-scratch'" @click="recPackageClick(list)">
          <img class="poster" :src="list.poster" alt="" />
          <div class="info">
            <h4>{{list.name.zh}}</h4>
            <p>{{list.totalUnits}}课时 (未报名)</p>
          </div>
          <!-- <img class="state" v-show="isSuccessHandler (list) === '正在学习'" src="@/assets/images/pking.png" alt="" /> -->
          <div class="lock"><img src="@/assets/images/lock.png" alt="" /></div>
        </li>
      </ul>
    </div>
    <!--公众号dialog -->
    <PackagesDialog
      v-show="showPackagesCode"
      @close="close"
      :title="title"
      :content="content"
      :code="qrCodeUrl"
    />

  </div>
</template>

<script>
import PackagesDialog from "../components/packagesDialog"; // 右边的组件

export default {
  data () {
    return{
      allPackages: [],
      recommended: [],
      packageId: '',
      showPackagesCode: false,//true,
      showPackage: {},
      title: "微信扫码解锁更多课程",
      content: '父母不在身边？通知爸爸妈妈帮忙解决。',
      qrCodeUrl: ''
    }
  },
  components: {
    PackagesDialog
  },
  mounted () {
    this.getAllPackages();
    this.packageId = this.$route.query.packageId;
  },
  methods: {
    close(arg) {
      this.showPackagesCode = arg;
    },
    getAllPackages() {
      //获取所有课程包
      this.axios.get("/v1/api/self/scratch/packages").then(res => {
        console.log("packages->scratch: ", res);
        //购买的
        this.allPackages = res.data.packages;
        //type: "scratch/archived" "archived" "live"排序
        this.packagesSort(res.data.packages);
        // 推荐的
        this.recommended = res.data.recommended;
      })
      .catch(error => {
        console.log(error);
      });
    },
    packagesSort (packages) {
      let saList = [], aList = [], lList = [];
      packages.forEach(element => {
        if(element.type == "scratch/archived"){
          saList.push(element);
        }else if(element.type == "archived"){
          aList.push(element);
        }else if(element.type == "live"){
          lList.push(element);
        }
      });
      this.allPackages = saList.concat(aList, lList);
    },
    packageClick (unit) {
      if(unit.type.startsWith("scratch/")){
        this.$router.push({path:'/', query:{'packageId': unit._id}});
      }else{
        if(/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
          window.open(`https://mooc.jikestar.com/liveui#/mobilephoneClass?packageId=${unit._id}`);
        } else {
          window.open(`https://mooc.jikestar.com/liveui#/topClassLiving?packageId=${unit._id}`);
        }
      }
    },
    recPackageClick (unit) {
      this.showPackagesCode = true;
      if(unit.type.startsWith("live")){
        // this.qrCodeUrl = 'https://mooc.jikestar.com/moocpay?classtype=bcastpy1-21-96#/bcastpy1-x-x';
        this.qrCodeUrl = require('@/assets/images/bcastpy1.png');
      }else{
        // this.qrCodeUrl = 'https://mooc.jikestar.com/moocpay?classtype=recordf1-7-68#/recordf1-x-x';
        this.qrCodeUrl = require('@/assets/images/recordf1.png');

      }
    },
    backHandler () {
      this.$router.push({path:'/', query:{'packageId': this.packageId}});
    },
    isSuccessHandler (list) {
      let now = new Date();
      let endDate = new Date(list.endDate).getTime();
      return endDate - now > 0 ? '正在学习':'已完成';
    }
  }
}
</script>

<style lang="stylus" scoped>
  position($p=absolute, $l=0, $t=0)
    position: $p;
    left: $l;
    top: $t;

  wh($w=100%, $h=100%)
    width: $w;
    height: $h;

  .packages
    // wh();
    // position();
    // position: relative;
    background-color: #E5FFED;
    padding: 20px 0;
    .choice-box
      wh(777px, 620px);
      background: #fff;
      box-shadow:0px 1px 13px 0px rgba(27,148,239,0.85);
      border: 7px solid #00AEE1;
      border-radius:34px;
      // position();
      // right: 0;
      // bottom: 0;
      margin: 0 auto;
      // margin-top: 20px;
      position:relative;
      .back-btn
        wh(46px, 34px);
        position(absolute, -80px);
        cursor: pointer;
        &:hover {
          transform: scale(1.2);
        }
      .title
        color: #FF8F00;
        font-size: 32px;
        text-align: center;
        font-weight: bold;
        margin: 34px 0;
      ul
        max-height: 450px;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        overflow: auto;
        .li-live
          background: #68DDFF;
          border: 4px solid #68DDFF;
          box-sizing: border-box;
          &:hover
            border: 4px solid #FF8F00;
        .li-scratch
          background: #FF8F00;
          border: 4px solid #FF8F00;
          box-sizing: border-box;
          &:hover
            border: 4px solid #68DDFF;
        .li-now
          background: #68DDFF;
          border: 4px solid #68DDFF;
          &:hover
            border: 4px solid #FF8F00;
        li
          list-style: none;
          wh(686px, 120px);
          border-radius:20px;
          display: flex;
          align-items: center;
          margin-bottom: 10px;
          cursor: pointer;
          position: relative;
          box-sizing: border-box;
          .poster
            wh(158px, 99px);
            margin-left: 18px;
            border-radius: 10px;
          .info
            width:400px;
            color: #fff;
            margin-left: 18px;
            h4
              font-size: 26px;
            p
              font-size: 22px;
          .state
            margin-right: 28px;
            wh(53px, 53px);
          .lock
            wh(686px, 120px);
            position();
            left: -4px;
            top: -4px;
            background:rgba(0,0,0,0.4);
            border-radius:20px;
            img
              wh(47px, 50px);
              position();
              left: initial;
              top: 30px;
              right: 36px;

</style>
